// initial state
const state = () => ({
    show: false,
    title: 'Atenção!',
    message: '',
    iconColor: 'warning',
    iconName: 'mdi-alert-outline',
    routerName: '',
    statusCode: '',
})

// getters
const getters = {
    getInformationModalState(state) {
        return state;
    },
}

// actions
const actions = {}

// mutations
const mutations = {
    setInformationModalState(state, payload) {
        state.show = payload.show;
        state.title = payload.title;
        state.message = payload.message;
        state.iconColor = payload.iconColor;
        state.iconName = payload.iconName;
        state.routerName = payload.routerName;
        state.statusCode = payload.statusCode;
    },

    setModalShow(state, payload) {
        state.show = payload;
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
